<template>
	<div class="import-shop-products">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h1>Delete Orders</h1>

		<p class="description">
			This will delete the orders from CSV.
		</p>

		<b-field class="file">
			<label class="csv-reader">
				<input type="file" @change="loadTextFromFile" />
			</label>
		</b-field>

		<div v-if="deleteErr.length > 0" class="delete-error">
			<div v-for="(data, key) of deleteErr" :key="key">Error: {{ data }}</div>
		</div>

		<div class="button-container">
			<div v-if="confirmation">
				<br />
				<p>ARE YOU SURE YOU WANT TO DELETE THESE ORDERS?</p>
				<br />
				<br />
				<div class="big-button" @click="deleteOrders()" v-if="!isLoading">
					CONFIRM!
				</div>
				<div class="big-button big-button-loading" v-else>
					DELETING
				</div>
			</div>

			<div class="big-button" v-if="!confirmation" @click="confirmFirst()">
				DELETE ORDERS
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'DeleteOrders',
	data: () => ({
		isLoading: false,
		content: [],
		deleteErr: [],
		confirmation: false
	}),

	computed: {},

	mounted: async function() {},

	watch: {},

	methods: {
		confirmFirst() {
			this.confirmation = true
		},

		loadTextFromFile(ev) {
			const file = ev.target.files[0]
			const reader = new FileReader()

			// reader.onload = e => this.$emit("load", e.target.result);
			reader.onload = event => {
				var raw = event.target.result.split(/\r?\n/)

				// Remove first row
				raw.shift()

				const newObj = {}
				// Loop every row to put it in array
				raw.map(async data => {
					var splitData = data.split(/,/)

					if (!newObj[splitData[0]]) {
						this.$set(newObj, splitData[0], [])
					}

					newObj[splitData[0]].push(splitData[1])
				})

				this.content = newObj
			}

			reader.readAsText(file)
		},

		deleteOrders: async function() {
			this.isLoading = true
			if (this.content) {
				for (const orderId in this.content) {
					if (orderId) {
						var data = {
							id: orderId
						}

						const deleteOrder = await this.$api.orderDelete({
							data
						})

						if (!deleteOrder) {
							this.deleteErr.push(orderId)
						}

						console.log(this.deleteErr)
					}
				}

				this.$swal.fire('Finished!')
			}

			this.confirmation = false

			this.isLoading = false
		}
	}
}
</script>

<style scoped>
@import '../styles/GeneralStyles.css';

.big-button-loading {
	background-color: #eee;
}

.delete-error {
	text-align: center;
	color: #ff0000;
	font-weight: bold;
	margin: 1em 0;
}

.button-container p {
	font-weight: bold;
	font-size: 16px;
}
</style>
